import CustomDropDown from "../../../components/DropDown";
import { Breadcrum } from "../../../components/Layout/breadcrum";
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "../../../assets/CloseIcon.svg";
import upwardArrow from "../../../assets/Filter/upArrow.svg";
import downwardArrow from "../../../assets/downwardArrow.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { POST, GET } from "../../../utils/webService";
import {
  GET_REPORTS,
  GET_REPORTS_LIST,
  FETCH_ALL_PARTNER,
} from "../../../utils/ApiUrls";
import AccessDenied from "../../../components/AccessDenied";
import { checkPageAuthorized } from "../../../redux/reducers/role";
import { toast } from "react-hot-toast";
import { convertXMLToXLSX } from "../../../utils/helper";
import { capitalizeFirstLetter } from "../../../utils/utility";
import { Spinner } from "../../../components/Spinner";
import OneButton from "../../../components/Button/OneButton";
import DateButton from "../../../components/Button/DateButton";
import saveAs from "file-saver";
import sessionManager from "../../../utils/sessionManager";
import downloadIcon from "../../../assets/download.svg";
import OnePagination from "../../../components/OnePagination/OnePagination";
import { useMediaQuery } from "react-responsive";

interface PreviousDownloadRow {
  id: string;
  reportName: string;
  dateRange: string;
  partner: string;
  type: string;
  generatedDateTime: string;
  downloadUrl?: string;
}

const Reports = () => {
  const isDesktopView = useMediaQuery({ minWidth: 1024 });
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [startDate, endDate] = dateRange;
  const [reportValue, setReportValue] = useState<any>("SHIPMENTSTATUS");
  const [typeValue, setTypeValue] = useState<string>("");
  const [isActive, setIsActive] = useState<any>(false);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [partnerMenu, setPartnerMenu] = useState<
    Array<{ label: string; value: string }>
  >([
    { label: "Select Partner", value: "" },
    { label: "N/A", value: "NA" },
  ]);
  const [accordianOpen, setAccordianOpen] = useState(false);
  const [filterArr, setFilterArr] = useState<string[]>([]);
  const [partners, setPartners] = useState<
    Array<{ value: string; label: string; isActive: boolean }>
  >([]);
  const selectPartnerRef = useRef<HTMLDivElement>(null);
  const [isLoadingPreviousDownloads, setIsLoadingPreviousDownloads] =
    useState(false);
  const [totalItemCount, setTotalItemCount] = useState(0);

  const { sellerInfo } = sessionManager({});
  const isImpersonateLogin = sellerInfo?.isImpersonateLogin ?? false;

  const reportMenu = [
    {
      label: "Shipment Status Report",
      value: "SHIPMENTSTATUS",
    },
    {
      label: "Shipment Error Report",
      value: "ERRORSHIPMENTSTATUS",
    },
    {
      label: "NPR Report",
      value: "NPRSTATUS",
    },
    // {
    //   label: "NDR Report",
    //   value: "NDRSTATUS",
    // },
    {
      label: "Product Wise Status Report",
      value: "PRODUCTWISESTATUS",
    },
    {
      label: "Serviceable Pincode Report",
      value: "SERVICEABLE_PINCODE",
    },
    {
      label: "New NPR Report",
      value: "NEW_NPR_REPORT",
    },
    {
      label: "Pickup Reconcilation Report",
      value: "PIKCUP_RECONCILATION",
    },
    {
      label: "RTO Reconcilation Report",
      value: "RTO_RECONCILIATION_REPORT",
    },
    {
      label: "Whatsapp Report",
      value: "WHATSAPP_REPORT",
    },
    {
      label: "Wallet Transaction Report",
      value: "WALLET_TRANSACTION_REPORT",
    },
    {
      label: "Group billing Report",
      value: "GROUP_BILLING_REPORT",
    },
    {
      label: "Email Report",
      value: "EMAIL_REPORT",
    },
  ];

  const typeMenu = [
    { label: "B2C", value: "B2C" },
    { label: "B2B", value: "B2B" },
  ];

  const [previousDownloads, setPreviousDownloads] = useState<
    PreviousDownloadRow[]
  >([]);

  const convertEpoch = (epochDate: any) => {
    return epochDate?.getTime() || "";
  };

  const reportEndDate = new Date();
  const isDateDisabled = (date: any) => date <= reportEndDate;

  const fetchReport = async () => {
    if (!reportValue) {
      toast.error("Please Select Report Name");
      return;
    }
    if (!startDate || !endDate) {
      toast.error("Please Select Date Range");
      return;
    }

    const endEpoch = new Date(endDate);
    endEpoch.setHours(23, 59, 59, 999);

    const payload: any = {
      apiStatus: reportValue,
      startDate: convertEpoch(startDate),
      endDate: endEpoch.getTime(),
    };
    if (typeValue) {
      payload.type = typeValue;
    }
    // Only include partnerNameArr if at least one partner is selected
    if (filterArr.length > 0) {
      payload.partnerNameArr = filterArr;
    }

    setIsLoading(true);

    if (reportValue === "GROUP_BILLING_REPORT") {
      const response = await POST(GET_REPORTS, payload, {
        responseType: "blob",
      });
      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8",
      });
      saveAs(blob, `GROUP_BILLING_${Date.now()}.csv`);
      setIsLoading(false);
      fetchPreviousDownloads();
      return;
    }

    const response = await POST(GET_REPORTS, payload);
    if (!response?.data?.success) {
      toast.error(response?.data?.message);
      setIsLoading(false);
      return;
    }

    const date = new Date().toISOString().slice(0, 10);
    await convertXMLToXLSX(
      response.data.data,
      `${capitalizeFirstLetter(reportValue)}_${date}.xlsx`,
    );
    toast.success("Downloaded successfully");
    setIsLoading(false);
    fetchPreviousDownloads();
  };

  useEffect(() => {
    setIsActive(checkPageAuthorized("Reports"));
  }, [isActive]);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await POST(FETCH_ALL_PARTNER, {});
        console.log("response partners", response);

        // Handle different response structures
        let partnerData: any = null;

        // Check if response has nested data structure (response.data.data)
        if (response?.data?.success && response?.data?.data) {
          partnerData = response.data.data;
        }
        // Check if response.data itself is the array (without success field)
        else if (Array.isArray(response?.data)) {
          partnerData = response.data;
        }
        // Check if response.data.data exists even without success field
        else if (response?.data?.data && Array.isArray(response.data.data)) {
          partnerData = response.data.data;
        }

        if (!partnerData) {
          console.error("No partner data found in response:", response);
          const errorMessage =
            response?.data?.message ||
            response?.message ||
            "Failed to fetch partners";
          if (response?.data?.success === false || !response?.data) {
            toast.error(errorMessage);
          }
          return;
        }

        // Check if partnerData is an array
        if (!Array.isArray(partnerData)) {
          console.error("Partner data is not an array:", partnerData);
          toast.error("Unexpected partner data format");
          return;
        }

        // If array is empty, set empty partners list
        if (partnerData.length === 0) {
          console.warn("No partners found in response");
          setPartnerMenu([{ label: "Select Partner", value: "" }]);
          setPartners([]);
          return;
        }

        // Transform partner data to consistent format
        let transformedPartners: Array<{ label: string; value: string }> = [];

        // If data is an array of strings
        if (typeof partnerData[0] === "string") {
          transformedPartners = partnerData.map((partner: string) => ({
            label: partner,
            value: partner,
          }));
        }
        // If data is an array of objects with partnerName property
        else if (partnerData[0]?.partnerName) {
          transformedPartners = partnerData.map((partner: any) => ({
            label: partner.partnerName,
            value: partner.partnerName,
          }));
        }
        // If data is an array of objects with name property
        else if (partnerData[0]?.name) {
          transformedPartners = partnerData.map((partner: any) => ({
            label: partner.name,
            value: partner.name,
          }));
        }
        // If data is already in the correct format
        else if (partnerData[0]?.label && partnerData[0]?.value) {
          transformedPartners = partnerData;
        } else {
          console.error("Unexpected partner data format:", partnerData[0]);
          toast.error("Unexpected partner data format");
          return;
        }

        // Sort partners alphabetically
        transformedPartners.sort(
          (
            a: { label: string; value: string },
            b: { label: string; value: string },
          ) => a.label.localeCompare(b.label),
        );

        // Set partner menu with default options + fetched partners
        setPartnerMenu([
          { label: "Select Partner", value: "" },
          // { label: "N/A", value: "NA" },
          ...transformedPartners,
        ]);
        console.log("transformedPartners", transformedPartners);
        // Sync partners list for multi-select (exclude placeholder options)
        const partnerOptions = transformedPartners.map(
          (p: { label: string; value: string }) => ({
            value: p.value,
            label: p.label,
            isActive: false,
          }),
        );
        console.log("partnerOptions", partnerOptions);
        setPartners(partnerOptions);
      } catch (error) {
        console.error("Error fetching partners:", error);
        toast.error("An error occurred while fetching partners");
      }
    };

    if (isActive !== false) {
      fetchPartners();
    }
  }, [isActive]);

  useEffect(() => {
    if (isActive !== false) {
      fetchPreviousDownloads();
    }
  }, [isActive, currentPage, itemsPerPage]);

  const handleClear = () => {
    setDateRange([null, null]);
  };

  const formatDate = (dateString: string | number) => {
    if (!dateString) return "";
    const date =
      typeof dateString === "number"
        ? new Date(dateString)
        : new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const formatDateTime = (dateString: string | number) => {
    if (!dateString) return "";
    const date =
      typeof dateString === "number"
        ? new Date(dateString)
        : new Date(dateString);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getPartnerFromQueryUsed = (queryUsed: any): string => {
    const orClauses = queryUsed?.match?.$and?.[0]?.$or;
    if (!Array.isArray(orClauses)) return "N/A";
    for (const clause of orClauses) {
      const partner =
        clause?.courierPartnerName?.$in?.[0] ??
        clause?.["service.partnerName"]?.$in?.[0];
      if (partner) return partner;
    }
    return "N/A";
  };

  const fetchPreviousDownloads = async () => {
    setIsLoadingPreviousDownloads(true);
    try {
      const payload = {
        page: currentPage,
        pageSize: itemsPerPage,
        limit: itemsPerPage,
        search: "",
        filter: {},
      };

      const response = await POST(GET_REPORTS_LIST, payload);

      if (response?.data?.success) {
        const reports = response.data.data || [];
        const pagination = response.data.pagination;
        const total =
          pagination?.totalCount ?? response.data.total ?? reports.length;

        // Map API response (reportType, queryUsed, fileLink, createdAt) to PreviousDownloadRow
        const mappedDownloads: PreviousDownloadRow[] = reports.map(
          (report: any) => {
            const match = report.queryUsed?.match || {};
            const createdAtRange = match.createdAt;
            const startEpoch = createdAtRange?.$gte;
            const endEpoch = createdAtRange?.$lte;
            const startDate = startEpoch != null ? formatDate(startEpoch) : "";
            const endDate = endEpoch != null ? formatDate(endEpoch) : "";
            const dateRange =
              startDate && endDate ? `${startDate} - ${endDate}` : "";

            return {
              id: report._id || report.id || String(report.createdAt ?? ""),
              reportName:
                report.reportType ||
                report.apiStatus ||
                report.reportName ||
                "",
              dateRange,
              partner: getPartnerFromQueryUsed(report.queryUsed),
              type: match.orderType || report.type || "B2C",
              generatedDateTime: formatDateTime(
                report.createdAt ??
                  report.startedAt ??
                  report.completedAt ??
                  "",
              ),
              downloadUrl:
                report.fileLink || report.downloadUrl || report.fileUrl || "",
            };
          },
        );

        setPreviousDownloads(mappedDownloads);
        setTotalItemCount(total);
      } else {
        toast.error(
          response?.data?.message || "Failed to fetch previous downloads",
        );
        setPreviousDownloads([]);
        setTotalItemCount(0);
      }
    } catch (error) {
      console.error("Error fetching previous downloads:", error);
      toast.error("An error occurred while fetching previous downloads");
      setPreviousDownloads([]);
      setTotalItemCount(0);
    } finally {
      setIsLoadingPreviousDownloads(false);
    }
  };

  const handleDownload = (row: PreviousDownloadRow) => {
    if (row.downloadUrl) {
      window.open(row.downloadUrl, "_blank");
    } else {
      toast.error("Download URL not available");
    }
  };

  const onPageIndexChange = (data: {
    currentPage: number;
    itemsPerPage: number;
  }) => {
    setCurrentPage(data.currentPage);
  };

  const onPerPageItemChange = (data: {
    currentPage: number;
    itemsPerPage: number;
  }) => {
    setCurrentPage(1);
    setItemsPerPage(data.itemsPerPage);
  };

  const removePartner = (partnerValue: string, index: number) => {
    setFilterArr((prev) => prev.filter((_, i) => i !== index));
    setPartners((prev) =>
      prev.map((p) =>
        p.value === partnerValue ? { ...p, isActive: false } : p,
      ),
    );
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectPartnerRef.current &&
        !selectPartnerRef.current.contains(event.target as Node)
      ) {
        setAccordianOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const cardGridClass =
    "grid grid-cols-[minmax(180px,1fr)_minmax(160px,1fr)_minmax(80px,1fr)_minmax(70px,1fr)_minmax(160px,1fr)_minmax(80px,1fr)] gap-4 items-center";

  return (
    <>
      {isActive === undefined || isActive ? (
        <div className="w-full">
          <div className="w-full">
            <Breadcrum label="Reports" />
          </div>

          {/* Selection: Report Name, Date Range, Partner, Type */}
          <div className="p-4 flex flex-col sm:flex-row flex-wrap gap-3 items-stretch sm:items-center border-b border-[#E8E8E8]">
            <div className="w-full sm:w-[240px]">
              <CustomDropDown
                heading="Select Report Name"
                value={reportValue}
                options={reportMenu}
                useNativeSelect={false}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  setReportValue(e.target.value)
                }
              />
            </div>
            <div className="w-full min-w-0 sm:w-auto sm:min-w-[240px]">
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update: any) => setDateRange(update)}
                filterDate={isDateDisabled}
                wrapperClassName="w-full block [&_.react-datepicker__input-container]:w-full"
                customInput={
                  <DateButton
                    text="Select Date"
                    onClick={() => {}}
                    className="w-full sm:w-auto"
                    value={
                      startDate && endDate
                        ? `${startDate.toLocaleDateString("en-US", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          })} - ${endDate.toLocaleDateString("en-US", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          })}`
                        : ""
                    }
                    onClear={handleClear}
                  />
                }
                dateFormat="dd/MM/yyyy"
              />
            </div>
            <div
              className="w-full sm:w-[320px] relative"
              ref={selectPartnerRef}
            >
              <div
                className="flex gap-x-2 border relative border-[#A4A4A4] rounded-md h-[48px] py-1.5 items-center text-[12px] px-3 w-full"
                onClick={() => setAccordianOpen((prev) => !prev)}
              >
                <div className="flex-1 min-w-0 text-[12px] overflow-hidden">
                  {filterArr.length === 0 ? (
                    <span className="text-[#777777]">Select Partner</span>
                  ) : (
                    <div className="flex flex-nowrap gap-x-1 items-center">
                      {filterArr.length > 2 ? (
                        <>
                          {filterArr
                            .slice(0, 2)
                            .map((partnerVal: string, index: number) => (
                              <span
                                key={`${partnerVal}-${index}`}
                                className="border border-[#A4A4A4] py-[2.5px] px-2 text-[10px] flex gap-x-2 items-center whitespace-nowrap shrink-0"
                              >
                                {partnerVal}
                                <img
                                  src={CloseIcon}
                                  alt=""
                                  className="w-3 h-3 cursor-pointer"
                                  onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    removePartner(partnerVal, index);
                                  }}
                                />
                              </span>
                            ))}
                          <span className="border border-[#A4A4A4] py-[2.5px] px-2 text-[10px] flex gap-x-2 items-center whitespace-nowrap shrink-0">
                            + {filterArr.length - 2}
                          </span>
                        </>
                      ) : (
                        filterArr.map((partnerVal: string, index: number) => (
                          <span
                            key={`${partnerVal}-${index}`}
                            className="border border-[#A4A4A4] py-[2.5px] px-2 text-[10px] flex gap-x-2 items-center whitespace-nowrap shrink-0"
                          >
                            {partnerVal}
                            <img
                              src={CloseIcon}
                              alt=""
                              className="w-3 h-3 cursor-pointer"
                              onClick={(e: React.MouseEvent) => {
                                e.stopPropagation();
                                removePartner(partnerVal, index);
                              }}
                            />
                          </span>
                        ))
                      )}
                    </div>
                  )}
                </div>
                {accordianOpen ? (
                  <img
                    src={upwardArrow}
                    alt=""
                    className="cursor-pointer shrink-0 ml-1"
                  />
                ) : (
                  <img
                    src={downwardArrow}
                    alt=""
                    className="cursor-pointer shrink-0 ml-1"
                  />
                )}
              </div>
              {accordianOpen && (
                <div
                  style={{ scrollbarWidth: "thin" }}
                  className="border absolute left-0 right-0 top-full mt-1 bg-white max-h-[50vh] overflow-y-auto z-50 border-[#A4A4A4] px-0 py-0 rounded-md shadow-lg"
                >
                  {partners
                    .filter((p) => p.value !== "" && p.value !== "NA")
                    .map(
                      (item: {
                        value: string;
                        label: string;
                        isActive: boolean;
                      }) => (
                        <div
                          key={item.value}
                          className="flex gap-x-2 py-1 mt-1 mb-2 px-2 items-center"
                        >
                          <input
                            type="checkbox"
                            id={`partner-${item.value}`}
                            checked={item.isActive}
                            value={item.value}
                            className="!w-3 !h-4 cursor-pointer"
                            onChange={(e) => {
                              const val = e.target.value;
                              setPartners((prev) =>
                                prev.map((p) =>
                                  p.value === val
                                    ? { ...p, isActive: !p.isActive }
                                    : p,
                                ),
                              );
                              if (item.isActive) {
                                setFilterArr((prev) =>
                                  prev.filter((v) => v !== val),
                                );
                              } else {
                                setFilterArr((prev) => [...prev, val]);
                              }
                            }}
                          />
                          <div
                            // htmlFor={`partner-${item.value}`}
                            className="min-w-[150px] text-[13px] cursor-pointer"
                          >
                            {item.label}
                          </div>
                        </div>
                      ),
                    )}
                </div>
              )}
            </div>
            <div className="w-full sm:w-[160px]">
              <CustomDropDown
                heading="Type"
                value={typeValue}
                options={typeMenu}
                useNativeSelect={false}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  setTypeValue(e.target.value)
                }
              />
            </div>
            {isLoading ? (
              <div className="border py-2 w-full sm:w-[180px] flex items-center justify-center h-12 rounded">
                <Spinner />
              </div>
            ) : (
              <OneButton
                onClick={fetchReport}
                text="GENERATE REPORT"
                className="px-4 py-3 w-full sm:w-[180px] h-12"
                variant="primary"
              />
            )}
          </div>

          {/* Previous Downloads */}
          <div className="p-4">
            <h2 className="font-Open text-lg font-semibold text-[#1C1C1C] mb-4">
              Previous Downloads
            </h2>

            {previousDownloads.length > 0 ? (
              isDesktopView ? (
                <div className="w-full overflow-x-auto">
                  <div
                    className={`${cardGridClass} px-4 py-3 bg-white font-Open text-sm font-semibold text-[#1C1C1C] border-b border-[#E8E8E8] rounded-t-lg min-w-[800px]`}
                  >
                    <span>Report Name</span>
                    <span>Date Range</span>
                    <span>Partner</span>
                    <span>Type</span>
                    <span>Date & Time</span>
                    <span>Download</span>
                  </div>
                  <div className="space-y-3 mt-3">
                    {previousDownloads.map((row: PreviousDownloadRow) => (
                      <div
                        key={row.id}
                        className={`${cardGridClass} px-4 py-4 bg-white rounded-lg shadow-sm border border-[#E8E8E8] hover:shadow-md transition-shadow min-w-[800px]`}
                      >
                        <span className="font-Open text-xs font-normal text-[#1C1C1C]">
                          {row.reportName}
                        </span>
                        <span className="font-Open text-xs font-normal text-[#1C1C1C]">
                          {row.dateRange}
                        </span>
                        <span className="font-Open text-xs font-normal text-[#1C1C1C]">
                          {row.partner}
                        </span>
                        <span className="font-Open text-xs font-normal text-[#1C1C1C]">
                          {row.type}
                        </span>
                        <span className="font-Open text-xs font-normal text-[#1C1C1C]">
                          {row.generatedDateTime}
                        </span>
                        <button
                          type="button"
                          onClick={() => handleDownload(row)}
                          className="w-9 h-9 rounded-full bg-[#004EFF] flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer shrink-0"
                          aria-label="Download report"
                        >
                          <img
                            src={downloadIcon}
                            alt=""
                            className="w-4 h-4 brightness-0 invert"
                          />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="space-y-4">
                  {previousDownloads.map((row: PreviousDownloadRow) => (
                    <div
                      key={row.id}
                      className="rounded-lg border border-[#E8E8E8] bg-white p-4 shadow-sm"
                    >
                      <div className="flex items-start justify-between gap-3">
                        <div className="min-w-0">
                          <div className="text-[15px] font-semibold text-[#1C1C1C] break-words">
                            {row.reportName || "-"}
                          </div>
                          <div className="mt-1 text-[12px] text-[#777777] break-words">
                            {row.dateRange || "-"}
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => handleDownload(row)}
                          className="w-9 h-9 rounded-full bg-[#004EFF] flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer shrink-0"
                          aria-label="Download report"
                        >
                          <img
                            src={downloadIcon}
                            alt=""
                            className="w-4 h-4 brightness-0 invert"
                          />
                        </button>
                      </div>

                      <div className="mt-4 grid grid-cols-1 gap-y-2 text-[13px] text-[#1C1C1C] sm:grid-cols-2 sm:gap-x-4">
                        <div className="min-w-0">
                          <span className="text-[#777777]">Report Name: </span>
                          <span className="break-words">{row.reportName || "-"}</span>
                        </div>
                        <div className="min-w-0">
                          <span className="text-[#777777]">Date Range: </span>
                          <span className="break-words">{row.dateRange || "-"}</span>
                        </div>
                        <div className="min-w-0">
                          <span className="text-[#777777]">Partner: </span>
                          <span className="break-words">{row.partner || "-"}</span>
                        </div>
                        <div className="min-w-0">
                          <span className="text-[#777777]">Type: </span>
                          <span>{row.type || "-"}</span>
                        </div>
                        <div className="min-w-0 sm:col-span-2">
                          <span className="text-[#777777]">Date & Time: </span>
                          <span className="break-words">
                            {row.generatedDateTime || "-"}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )
            ) : null}

            {totalItemCount > 0 && (
              <OnePagination
                totalItems={totalItemCount}
                itemsPerPageOptions={[10, 20, 50, 100]}
                initialItemsPerPage={itemsPerPage}
                onPageChange={onPageIndexChange}
                onItemsPerPageChange={onPerPageItemChange}
              />
            )}

            {previousDownloads.length === 0 && (
              <div className="text-center py-8 text-[#777] text-sm font-Open border border-[#E8E8E8] rounded-lg bg-white">
                No previous downloads found.
              </div>
            )}
          </div>
        </div>
      ) : (
        <AccessDenied />
      )}
    </>
  );
};

export default Reports;
